module.exports = __webpack_public_path__ + "static/media/caramida-aparenta-klinker-Wickford.079776af.jpg";